var _excluded = ["boxSize", "className", "onLoadErrorPath", "src"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { string, oneOf } from "prop-types";
import classNamesMaker from "classnames";
import DefaultAvatar from "#library/assets/images/default_avatar.svg";
import { Image, BOX_SIZES } from "./Image";
import styles from "./image.module.css";
var Avatar = function Avatar(_ref) {
  var boxSize = _ref.boxSize,
    className = _ref.className,
    onLoadErrorPath = _ref.onLoadErrorPath,
    src = _ref.src,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var imageClassName = classNamesMaker(className, styles["jds-Image__box--".concat(boxSize)], styles["jds-Image__box--circle"], styles["jds-Image__box--undistorted"]);

  /*
    We explicitely specify the altered props
    and transfer the others as is with a spread attribute.
     As `onLoadErrorPath` and `src` are not altered here but in `defaultProps`
    we would _technically_ not need to specify them.
    But we do it to highlight their particular behaviour.
  */
  return /*#__PURE__*/React.createElement(Image, _extends({
    className: imageClassName,
    onLoadErrorPath: onLoadErrorPath,
    src: src
  }, restProps));
};
Avatar.defaultProps = {
  boxSize: BOX_SIZES.SMALL,
  className: "",
  // if no onLoadErrorPath is provided, the default avatar is the fallback
  onLoadErrorPath: DefaultAvatar,
  // if no src is provided, use the default avatar
  src: DefaultAvatar
};
Avatar.propTypes = {
  boxSize: oneOf(Object.values(BOX_SIZES)),
  className: string,
  onLoadErrorPath: string,
  src: string
};
export { Avatar };